import { MagnifyingGlass, Calendar, X } from "@phosphor-icons/react";
import { STATUS_LABELS } from "@/lib/api";

const MARKETPLACE_CHIPS = [
  { key: "all",           label: "Todos",         bg: "#000",    fg: "#fff" },
  { key: "shopee",        label: "Shopee",        bg: "#EE4D2D", fg: "#fff" },
  { key: "mercado_livre", label: "Mercado Livre", bg: "#FFE600", fg: "#000" },
  { key: "bling_direto",  label: "Direto",        bg: "#3F3F46", fg: "#fff" },
];

export default function OrdersFiltersBar({
  search, setSearch,
  statusFilter, setStatusFilter,
  skuFilter, onSkuChange, skuOptions,
  dateField, setDateField, dateStart, setDateStart, dateEnd, setDateEnd,
  onApply, onClearDates,
  marketplaceFilter, onMarketplaceChange, marketplaceCounts,
}) {
  return (
    <>
      {/* Filtros unificados — o botão Buscar aplica todos os campos de uma vez */}
      <div className="flex items-center gap-2 mb-6 flex-wrap" data-testid="filters-bar">
        <div className="relative flex-1 min-w-[240px]">
          <MagnifyingGlass size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400" />
          <input className="input pl-10" placeholder="Buscar por número (ex: #M0001), cliente, contato ou pedido na loja (Shopee/ML)" value={search} onChange={(e) => setSearch(e.target.value)} onKeyDown={(e) => e.key === "Enter" && onApply()} data-testid="search-input" />
        </div>
        <select className="input max-w-[190px]" value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} data-testid="status-filter">
          <option value="all">Todos os status</option>
          {Object.entries(STATUS_LABELS).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
        </select>
        <select
          className="input max-w-[170px] font-mono text-sm"
          value={skuFilter}
          onChange={(e) => onSkuChange(e.target.value)}
          data-testid="sku-filter"
          title="Filtrar pedidos que contêm o SKU selecionado"
        >
          <option value="all">Todos os SKUs</option>
          {skuOptions.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>
        <div className="flex items-center gap-2">
          <Calendar size={16} className="text-zinc-500" />
          <select className="input max-w-[210px]" value={dateField} onChange={(e) => setDateField(e.target.value)} data-testid="date-field-select">
            <option value="order_date">Data do Pedido</option>
            <option value="exit_date">Data Limite de Envio</option>
          </select>
          <input
            type="date"
            className="input max-w-[150px]"
            value={dateStart}
            onChange={(e) => setDateStart(e.target.value)}
            data-testid="date-start-input"
            aria-label="Data inicial"
          />
          <span className="text-zinc-400 text-sm">até</span>
          <input
            type="date"
            className="input max-w-[150px]"
            value={dateEnd}
            onChange={(e) => setDateEnd(e.target.value)}
            data-testid="date-end-input"
            aria-label="Data final"
          />
        </div>
        <button className="btn w-28 justify-center" onClick={onApply} data-testid="apply-filters-btn">Buscar</button>
        {(dateStart || dateEnd) && (
          <button className="btn btn-ghost w-28 justify-center" onClick={onClearDates} data-testid="clear-date-filter-btn">
            <X size={14} /> Limpar
          </button>
        )}
      </div>

      {/* Quick marketplace filter chips — contadores refletem o TOTAL real
          considerando os outros filtros ativos (status, busca, data). */}
      <div className="flex items-center gap-2 mb-4 flex-wrap" data-testid="marketplace-chips">
        {MARKETPLACE_CHIPS.map((c) => {
          const active = marketplaceFilter === c.key;
          return (
            <button
              key={c.key}
              type="button"
              onClick={() => onMarketplaceChange(c.key)}
              className={`text-xs font-bold uppercase tracking-widest px-3 py-1.5 border transition-all ${active ? "border-black" : "border-zinc-300 hover:border-black"}`}
              style={active ? { backgroundColor: c.bg, color: c.fg, borderColor: c.bg } : { backgroundColor: "transparent", color: "#000" }}
              data-testid={`marketplace-chip-${c.key}`}
              aria-pressed={active}
            >
              <span>{c.label}</span>
              <span className={`ml-2 inline-block min-w-[1.5rem] text-center font-mono ${active ? "" : "text-zinc-500"}`}>{marketplaceCounts[c.key] ?? 0}</span>
            </button>
          );
        })}
      </div>
    </>
  );
}
